import React from 'react'

const CustomGroupCellContent = ({ row }) => (<span>{row.value}</span>)

export default CustomGroupCellContent
